// extracted by mini-css-extract-plugin
module.exports = {"tasksPage":"tasksPage__j9SAn","content":"content__08xG9","item":"item__fIeSB"};